class GiftPackaging extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleRadioChange = this.handleRadioChange.bind(this)

    if (this.els.radio?.exists) {
      this.els.radio.elements.forEach((radio) => {
        this.listeners.add(radio, 'change', this.handleRadioChange)
      })
    }
  }

  handleRadioChange(event) {
    const selectedValue = event.target.value
    this.addToCart(selectedValue)
  }

  addToCart(giftPackagingValue) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          'gift-packaging': giftPackagingValue,
        },
      })
    })
      .then(response => response.json())
      .catch((error) => {
        console.error('Error updating cart:', error)
      })
  }

}

if (!customElements.get('gift-packaging')) {
  customElements.define('gift-packaging', GiftPackaging)
}
